// Icons
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiMailSend,
  BiSolidPhoneCall,
} from 'react-icons/bi'

const Footer = () => {
  const currentDate = new Date().getFullYear()
  return (
    <footer className='footer'>
      <div className='footer-socials'>
        <div className='footer-socials'>
          <a href='https://www.facebook.com/LDTHlavas/' target='blank'>
            <BiLogoFacebook className='footer-socials-icon' />
          </a>
          <a
            href='https://instagram.com/ldthlavas?igshid=YmMyMTA2M2Y='
            target='blank'
          >
            <BiLogoInstagramAlt className='footer-socials-icon' />
          </a>
          <a href='mailto:hlavas@hotmail.com'>
            <BiMailSend className='footer-socials-icon' />
          </a>
          <a href='tel:420739001411'>
            <BiSolidPhoneCall className='footer-socials-icon' />
          </a>
        </div>
      </div>
      <div className='footer-copyright'>
        Copyright © {currentDate} Hlavas, z.s.
      </div>
    </footer>
  )
}

export default Footer
